import React from 'react'
import styled from 'styled-components'

import './caterer.scss'
import Layout from '../components/Layout/Layout'
import traiteur from '../assets/traiteur.png'

const Image = styled.div`
  background: url(${traiteur}) no-repeat;
`

const Caterer = ({ pathContext: { locale } }) => {
  return (
    <Layout locale={locale}>
      <div className="row no-gutters caterer">
        <div className="col-12 col-lg-5 col-xl-4 pr-0 pr-lg-5">
          <h5 className="text-uppercase title">Banoi sur mesure</h5>

          <p className="courier-new text">
            Rafraîchissantes et originales, nos recettes sont idéales pour composer un buffet.
          </p>

          <p className="courier-new text">
            Des bouchées de rouleaux de printemps aux tartinettes de Banh-Mi en passant par des
            verrines de panna cocotta, Banoi ravira vos convives.
          </p>

          <p className="courier-new text">
            Habitués aux événements professionnels, culturels ou privés comme un mariage,
            faites-nous part de votre projet et nous composerons ensemble le menu adapté à vos
            envies.
          </p>

          <u>
            <a className="courier-new text" href="mailto:contact@banoi.fr">
              Racontez-nous votre projet
            </a>
          </u>
        </div>

        <Image className="col-12 col-lg-7 col-xl-8 mt-4 mt-sm-0 img-right" />
      </div>
    </Layout>
  )
}

export default Caterer



// WEBPACK FOOTER //
// ./src/pages/caterer.js